import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AuthService } from '@auth/auth.service';
import { SigninData } from '@auth/shared/signin-data.interface';
import * as authSelectors from '@auth/store/auth.selectors';
import { DataService } from '@data/data.service';

@Component({
  selector: 'app-screen-title',
  templateUrl: './screen-title.component.html',
  styleUrls: ['./screen-title.component.scss'],
})
export class ScreenTitleComponent implements OnInit, OnDestroy {
  @Input() title: string;

  public authState$: Observable<SigninData>;
  public screenTitle$: any;

  constructor(private store: Store, public dataService: DataService, public authService: AuthService) {}

  ngOnInit() {
    this.authState$ = this.store.select(authSelectors.selectAuthData);
    this.screenTitle$ = this.store.select(authSelectors.selectCurrScreen);
  }

  ngOnDestroy() {}
}
